var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 0,
    width: 58,
    height: 116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.072 115.35H63.1369C92.579 112.774 115.681 87.983 115.681 57.7874C115.681 25.8779 89.8871 0 58.072 0V115.35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.89716 51.6341L-10.7637 53.7882L126.57 172.473L126.767 172.641L128.634 170.487L-8.70019 51.8027L-8.89716 51.6341Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.0467 57.572L-15.9132 59.7262L121.43 178.401L121.618 178.57L123.484 176.425L-13.8497 57.7406L-14.0467 57.572Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.74799 45.6962L-5.6145 47.8503L131.719 166.535L131.916 166.694L133.774 164.549L-3.5604 45.8648L-3.74799 45.6962Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.196 63.5099L-21.0531 65.6641L116.281 184.348L116.478 184.517L118.335 182.363L-18.999 63.6785L-19.196 63.5099Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6906 27.8821L9.8241 30.0363L147.158 148.711L147.355 148.88L149.212 146.735L11.8782 28.0507L11.6906 27.8821Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3918 39.758L-0.465332 41.9121L136.869 160.587L137.066 160.756L138.923 158.611L1.58877 39.9266L1.3918 39.758Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0277 22.1128L16.8308 21.9442L14.9736 24.0984L152.308 142.773L152.505 142.942L154.362 140.797L17.0277 22.1128Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54144 33.8201L4.67493 35.9742L142.009 154.649L142.206 154.818L144.072 152.673L6.7384 33.9887L6.54144 33.8201Z",
    fill: "#FFA489"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_260_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 0,
    width: 58,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.072 57.8811L101.161 96.2718C110.184 86.0536 113.326 72.4263 115.671 57.8811C115.803 57.0943 115.906 56.317 115.981 55.5396V47.0728C113.279 21.0451 86.079 0.00933838 58.0626 0.00933838V57.8904L58.072 57.8811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_260_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7564 35.7215C63.1461 35.7215 56.1302 42.7365 56.1302 51.3531C56.1302 59.9697 63.1461 66.9848 71.7564 66.9848C80.2823 66.9848 87.2419 60.1102 87.3826 51.6154V51.1003C87.2419 42.6054 80.2823 35.7309 71.7564 35.7215ZM71.7564 64.1376C64.7218 64.1282 58.991 58.3869 58.9722 51.3531C58.991 44.3194 64.7218 38.5781 71.7564 38.5687C78.791 38.5781 84.5218 44.3194 84.5406 51.3531C84.5218 58.3869 78.791 64.1188 71.7564 64.1376Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7564 44.5441C68.0046 44.5441 64.9469 47.6067 64.9469 51.3624C64.9469 55.1181 68.0046 58.1714 71.7564 58.1714C75.5082 58.1714 78.4252 55.2493 78.5659 51.6153V51.1002C78.4345 47.4662 75.4237 44.5441 71.7564 44.5441ZM71.7564 55.3242C69.571 55.3242 67.7983 53.5447 67.7889 51.3624C67.7889 49.1802 69.571 47.4007 71.7564 47.4007C73.9418 47.4007 75.7239 49.1802 75.7239 51.3624C75.7239 53.5447 73.9418 55.3242 71.7564 55.3242Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7563 26.2526C57.9216 26.2526 46.6569 37.5104 46.6569 51.3531C46.6569 65.1959 57.9122 76.4537 71.7563 76.4537C85.5065 76.4537 96.715 65.327 96.8557 51.606V51.0909C96.715 37.3699 85.5159 26.2432 71.7563 26.2432V26.2526ZM71.7563 73.6064C59.5067 73.5877 49.527 63.6037 49.5082 51.3531C49.527 39.1026 59.5161 29.1186 71.7563 29.0998C84.0058 29.1186 93.9856 39.1026 94.0043 51.3531C93.9762 63.6037 83.9964 73.5877 71.7563 73.6064Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7565 16.7837C52.6975 16.7837 37.1932 32.2935 37.1932 51.3531C37.1932 70.4127 52.6975 85.9225 71.7565 85.9225C90.8156 85.9225 106.188 70.5531 106.32 51.606V51.0909C106.179 32.1437 90.7311 16.7743 71.7565 16.7743V16.7837ZM71.7565 83.0847C54.3014 83.0566 40.0727 68.8205 40.0352 51.3625C40.0633 33.9045 54.3014 19.6683 71.7565 19.6403C89.2117 19.6683 103.45 33.9045 103.478 51.3625C103.44 68.8205 89.2117 83.0566 71.7565 83.0847Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7565 -11.6324C37.0337 -11.6324 8.78284 16.6244 8.78284 51.3531C8.78284 86.0817 37.0337 114.339 71.7565 114.339C106.479 114.339 134.589 86.2222 134.73 51.606V51.0908C134.589 16.4746 106.395 -11.6418 71.7565 -11.6418V-11.6324ZM71.7565 111.501C38.6658 111.435 11.6905 84.4614 11.6248 51.3624C11.6811 18.2634 38.6564 -8.71963 71.7565 -8.77583C104.847 -8.71963 131.822 18.2634 131.888 51.3624C131.822 84.4614 104.847 111.445 71.7565 111.501Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7566 -2.16333C42.2582 -2.16333 18.2562 21.8414 18.2562 51.3533C18.2562 80.8651 42.2582 104.87 71.7566 104.87C101.171 104.87 125.126 80.9963 125.257 51.6155V51.1004C125.116 21.7103 101.171 -2.16333 71.7566 -2.16333ZM71.7566 102.023C43.8715 101.976 21.1545 79.2448 21.0982 51.3533C21.1545 23.4617 43.8715 0.730726 71.7566 0.683896C99.6417 0.730726 122.368 23.4617 122.415 51.3533C122.359 79.2448 99.6417 101.976 71.7566 102.023Z",
    fill: "#FFA489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7564 7.30536C47.473 7.30536 27.7198 27.0673 27.7198 51.3531C27.7198 75.6388 47.473 95.3914 71.7564 95.3914C96.0398 95.3914 115.652 75.7699 115.793 51.6059V51.0908C115.652 26.9269 95.9553 7.30536 71.7564 7.30536ZM71.7564 92.5442C49.0862 92.5067 30.6087 74.0185 30.5712 51.3437C30.6087 28.6689 49.0862 10.19 71.7564 10.1432C94.4265 10.1807 112.904 28.6689 112.951 51.3437C112.904 74.0185 94.4265 92.4974 71.7564 92.5442Z",
    fill: "#FFA489"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_260_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 116,
    height: 116
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.660278 57.7874C0.660278 87.9924 23.7619 112.784 53.204 115.35H63.3338C92.7759 112.774 115.877 87.983 115.877 57.7874C115.877 25.8779 90.084 0 58.2689 0C26.4538 0 0.660278 25.8685 0.660278 57.7874Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_260_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4378 148.084H55.549V-33.024H58.4378V148.084ZM50.5779 148.084H47.689V-33.024H50.5779V148.084ZM42.7179 148.084H39.829V-33.024H42.7179V148.084ZM34.8485 148.084H31.9597V-33.024H34.8485V148.084ZM26.9792 148.084H24.0903V-33.024H26.9792V148.084ZM19.1192 148.084H16.2303V-33.024H19.1192V148.084ZM11.2498 148.084H8.36096V-33.024H11.2498V148.084ZM3.38985 148.084H0.500977V-33.024H3.38985V148.084Z",
    fill: "#FFA489"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogo);
export default __webpack_public_path__ + "static/media/loadingLogo.026431316cbce5cf4c8f5cbaf4aa7cfe.svg";
export { ForwardRef as ReactComponent };